export default __webpack_public_path__ + "static/media/config_6.fbb4e92f.png";